<template>
  <div
    class="pc-live-calendar"
    :class="{
      'electron-live-calendar': isElectron,
    }"
  >
    <div class="calendar">
      <my-calendar
        :markDate="markDate"
        @clickDay="handleClickDay"
        @changeMonth="handleChangeMonth"
        @showAllData="showAllData"
        @jumpToday="handleJumpToday"
        :showJumpTodayBtn="true"
      ></my-calendar>
    </div>
    <div class="right-cont">
      <!-- 列表 -->
      <ul
        v-if="showDataList.length"
        class="live-list-wrap"
        @scroll="handleScroll"
      >
        <li
          class="live-item"
          v-for="item in showDataList"
          :key="item.lesson_id"
        >
          <div class="time-axis" :class="{ 'can-join': item.liveStatus === 3 }">
            <p v-if="showAll" v-html="liveInThisYear(item)"></p>
            <span>{{
              moment(item.live_start_time * 1000).format("HH:mm")
            }}</span>
          </div>
          <div class="live-card" @click="goLiveRoom(item)">
            <img
              class="cover"
              :src="item.cover_url + '?imageView2/0/w/320'"
              alt=""
            />
            <div class="live-info">
              <p class="name">
                {{ item.lesson_name }}
              </p>
              <div>
                <p class="course-name">
                  所属课程：<span>{{ item.course_name }}</span>
                </p>
                <p class="unit-name">
                  所属单元：<span>{{ item.unit_name }}</span>
                </p>
              </div>
            </div>
            <div class="operate-wrap">
              <button
                v-if="item.liveStatus === 1 && item.is_record === 1"
                class="text-btn"
              >
                观看视频
              </button>
              <button v-else-if="item.liveStatus === 3" class="join-live-btn">
                <img src="../../../assets/images/living-white.gif" alt="" />
                进入直播
              </button>
              <span v-else class="tips-text">{{ item.tips }}</span>
            </div>
          </div>
        </li>
      </ul>
      <el-empty
        v-else
        description="暂无内容"
        :image="require('@/assets/img/live-list/empty.png')"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import liveCalendar from "./mixins/live-calendar.js";
export default {
  mixins: [liveCalendar],
};
</script>

<style lang="scss" scoped>
.pc-live-calendar {
  min-height: calc(100vh - 110px);
  display: flex;
  .calendar {
    width: 330px;
    margin-right: 15px;
  }
  .right-cont {
    flex: 1;
    .live-list-wrap {
      max-height: calc(100vh - 130px);
      overflow-y: auto;
      .live-item {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        position: relative;
        left: 5px;
        &::after {
          position: absolute;
          left: 4px;
          top: 50%;
          display: block;
          content: "";
          width: 1px;
          height: 122px;
          background: var(--border-color, #e5e6eb);
        }
      }
      .live-item:last-child {
        &::after {
          display: none;
        }
      }
      .can-join.time-axis {
        color: var(--text-primary, #333333);
        &::after {
          background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        }
        &::before {
          position: absolute;
          left: -5px;
          top: 50%;
          transform: translateY(-50%);
          display: block;
          content: "";
          border-radius: 50%;
          width: 18px;
          height: 18px;
          background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
          opacity: 0.2;
        }
      }
      .time-axis {
        width: 95px;
        padding-left: 18px;
        position: relative;
        font-weight: 500;
        font-size: 16px;
        color: var(--text-secondary, #747573);
        &::after {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          display: block;
          content: "";
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: var(--text-tertiary, #c9cdd4);
        }
      }
      .live-card {
        flex: 1;
        display: flex;
        align-items: center;
        width: 600px;
        height: 122px;
        background: var(--card-bg, #ffffff);
        border-radius: 24px;
        cursor: pointer;
        padding: 0 16px;

        .cover {
          width: 160px;
          height: 90px;
          margin-right: 12px;
          object-fit: cover;
          border-radius: 16px;
        }
        .live-info {
          width: 0;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 90px;
          .name {
            font-weight: 500;
            font-size: 18px;
            color: var(--text-primary, #0d1400);
            line-height: 28px;
            margin-bottom: 8px;
          }
          .course-name,
          .unit-name {
            font-weight: 400;
            font-size: 14px;
            color: var(--text-secondary, #747573);
            line-height: 20px;
          }
          .course-name {
            margin-bottom: 4px;
          }
          .name,
          .course-name,
          .unit-name {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .name {
            margin-bottom: 8px;
          }
        }
        .operate-wrap {
          min-width: 80px;
          margin-left: 8px;
          display: flex;
          justify-content: flex-end;
          .tips-text {
            font-weight: 400;
            font-size: 14px;
            color: var(--text-secondary, #747573);
            line-height: 20px;
            width: 80px;
          }
        }
        .text-btn {
          font-size: 16px;
          color: var(--text-primary, #0d1400);
          line-height: 22px;
        }
        .join-live-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 90px;
          height: 30px;
          background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
          border-radius: 15px;
          img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 18px;
        }
      }
    }
    .live-list-wrap {
      padding-right: 10px;
    }
    .live-list-wrap::-webkit-scrollbar {
      width: 7px;
    }
    .live-list-wrap::-webkit-scrollbar-thumb {
      background: var(--text-tertiary, #c1c1c1);
      border-radius: 4px;
    }
    .el-empty {
      height: 100%;
      background: var(--card-bg, #fff);
      border-radius: 12px;
    }
  }
}

// 客户端
.pc-live-calendar.electron-live-calendar {
  ::v-deep .calendar {
    width: 300px;
    margin-right: 15px;
    #comp_calender {
      width: 300px;
      .wh_content_item {
        font-size: 14px;
      }
    }
  }
  .right-cont {
    .live-list-wrap {
      .live-item {
        padding-bottom: 12px;
        &::after {
          height: 100px;
        }
      }
      .time-axis {
        width: 80px;
        padding-left: 14px;
        font-size: 14px;
      }
      .live-card {
        width: calc(100% - 65px);
        height: 102px;
        border-radius: 16px;
        padding: 0 20px 0 12px;

        .cover {
          width: 142px;
          height: 80px;
          margin-right: 8px;
          object-fit: cover;
          border-radius: 16px;
        }
        .live-info {
          height: 80px;
          .name {
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 6px;
          }
          .course-name,
          .unit-name {
            font-size: 12px;
            line-height: 17px;
          }
          .course-name {
            margin-bottom: 4px;
          }
        }
        .operate-wrap {
          width: 90px;
          margin-left: 5px;
          .status {
            font-weight: 400;
            font-size: 14px;
            color: #747573;
            line-height: 20px;
          }
        }
        .join-live-btn {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
